/* eslint-disable @typescript-eslint/no-explicit-any */
export function callAll(...fns: any[]) {
  return (...args: any[]) => {
    fns.forEach(fn => typeof fn === 'function' && fn(...args))
  }
}
